import dayjs, { Dayjs } from 'dayjs'

/** The wire format both the URL sync and the paginated endpoints expect. */
const DATE_FORMAT = 'YYYY-MM-DD'

/**
 * A table's date range travels as two single-entry `startDate`/`endDate` filter
 * arrays, while the `RangePicker` speaks `[Dayjs, Dayjs]`. These two helpers
 * convert between the two so a page never has to spell the mapping out twice
 * (once to seed the picker, once to read it back).
 */
const dateRangeFromFilters = (
  filters: Record<string, any>
): [Dayjs, Dayjs] | null =>
  filters.startDate && filters.endDate
    ? [dayjs(filters.startDate[0]), dayjs(filters.endDate[0])]
    : null

const dateRangeToFilters = (
  dateRange?: (Dayjs | null)[] | null
): { startDate?: string[]; endDate?: string[] } =>
  dateRange && dateRange[0] && dateRange[1]
    ? {
        startDate: [dayjs(dateRange[0]).format(DATE_FORMAT)],
        endDate: [dayjs(dateRange[1]).format(DATE_FORMAT)],
      }
    : {}

export { dateRangeFromFilters, dateRangeToFilters }
